<div class="header">
        <h3>{{ 'catalog.common.xenialDetails.externalFields' | translate }} </h3>

    <div class="header-actions">
    </div>
</div>

<div class="messages">
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="xenialBrandIdSetupErrorMsg"
                 *ngIf="xenialBrandIdSetupError">
        {{ 'catalog.common.xenialDetails.xenialBrandIdSetupError' | translate }}
    </txp-message>

    <txp-message [type]="messageType.DANGER"
                 data-qa-label="showLoadingXenialError"
                 *ngIf="showLoadXenialError">
        {{ 'catalog.common.xenialDetails.showLoadXenialError' | translate }}
    </txp-message>
</div>

<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading"></txp-loading>

<div class="form-content" *ngIf="!xenialBrandIdSetupError">
    <txp-change-set-notice
        [activeVersion]="selectedVersion"
        [itemChanges]="itemChanges"
        [customDecider]="hasFieldChanged.bind(this, 'xenialDetails', 'xenialDetails')"
        [noticeAlign]="'top'"
        [noticeType]="'icon'"
        [eventDetail]="'xenialDetails'">
        <div class="content" [formGroup]="form" formSubmittedSync>
            <ng-container *ngIf="shouldShowExternalFields">
                <mat-form-field class="major-reporting-category">
                    <mat-label>{{ 'catalog.common.xenialDetails.majorReportingCategory' | translate }}</mat-label>
                    <mat-select matInput
                                [required]="requireExternal"
                                data-qa-label="majorCategoryId"
                                formControlName="majorCategoryId">
                        <ng-container>
                            <mat-option *ngFor="let option of majorOptions" [value]="option.id">
                                        {{ option.label }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                    <mat-error>
                        {{ 'form.error.required' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="minor-report">
                    <mat-label>{{ 'catalog.common.xenialDetails.minorReport' | translate }}</mat-label>
                    <mat-select matInput
                                [required]="requireExternal"
                                data-qa-label="MinorCategoryId"
                                formControlName="minorCategoryId">
                        <ng-container>
                            <mat-option *ngFor="let option of minorOptions" [value]="option.id">
                                {{ option.label }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                    <mat-error>
                        {{ 'form.error.required' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="external-plu">
                    <mat-label>{{ 'catalog.common.xenialDetails.externalPlu' | translate }}</mat-label>
                    <input formControlName="rawPosValue"
                            data-qa-label="rawPosValue"
                            [required]="requireExternal"
                            matInput />
                    <mat-error>
                        {{ 'form.error.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </ng-container>
        </div>
    </txp-change-set-notice>
</div>